<template>

  <div class="picalbum-detail" >
    <div>
<!--    <div class="picalbums-detail__bac">
      <img :src="zhuantiImg" alt="" >
      <div class="picalbums-detail__bac-cover" ></div>
    </div>-->
    <div class="picalbum-detail__content" am-width="md" >
      <div class="picalbums-detail-top picalbum-detail__top" data-v-d043b1dc="" >
<!--        <div class="picalbums-detail-top__cover" data-v-d043b1dc="">
          <img :src="zhuantiImg" alt="" data-v-d043b1dc="">
        </div>-->
        <div class="picalbums-detail-top__info" data-v-d043b1dc="">
          <div class="picalbums-detail-top__title" data-v-d043b1dc=""><h2 data-v-d043b1dc="">{{zhuantiTitle}}</h2>
<!--            机车车辆 机车 电力机车 机车 客车 SSE 鹰山 桥-->
          </div>
          <span data-v-d043b1dc="">{{total}}张图片</span>

<!--
          <div class="picalbums-detail-top__tag-list" data-v-d043b1dc="">
            <a class="picalbums-detail-top__tag-item" href="javascript:void(0)" v-for="item of fenZhuantiList" target="_blank"  data-v-d043b1dc=""  @click="toFenzhuantiList(item.VConfigId)">{{item.VName}}</a>
          </div>
-->

        </div>
        </div>

    </div>


    <div class="inspiration" data-v-49099636="" >
      <div class="inspiration__content" data-v-49099636="">
        <div id="inspiration__content-item-0" class="inspiration__content-item" data-v-49099636="">
          <div class="inspiration__content-item-top" data-v-49099636="">
            <div class="inspiration__content-item-title" data-v-49099636=""></div>
<!--            <div class="inspiration__change-btn" data-v-49099636=""><img
              src="https://static.paixin.com/paixin-ssr/client/static/images/reflash.9cd4caa6.svg" alt=""
              data-v-49099636=""></div>-->
          </div>
          <div class="inspiration__content-item-list"   data-v-49099636="">
            <a class="s-c inspiration__stairscoat" v-for="item of rows" href="javascript:void(0)"
                             target="_blank" data-v-25f634ee=""  data-v-49099636=""  @click="toImg(item.VAttachId)">
<!--            <div class="s-c__b2" data-v-25f634ee=""></div>-->
            <div class="s-c__ct" data-v-25f634ee=""><img class="s-c__img lazyload s-c__i--s lazy"
                                                         data-v-25f634ee="" :src="item.VAttachmentRemotePath">
              <div class="s-c__if" data-v-25f634ee="">
                <div class="default-cover" data-v-2ee9cf5e="" data-v-49099636="" data-v-25f634ee-s="">
                  <div class="default-cover__top" data-v-2ee9cf5e=""><!----></div>
                  <div class="default-cover__bottom" data-v-2ee9cf5e=""><!--<h4 class="default-cover__title-text"
                                                                            data-v-2ee9cf5e="">{{item.VAttachmentName}}</h4>--></div>
                </div>
              </div>
            </div>
          </a>

          </div>
        </div>
      </div>


    </div>


    </div>
    <div class="block" style="z-index: 99999;margin-bottom: 10px;height: 0.4rem !important;" v-if="rows.length">
      <el-pagination
        @current-change="getPage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        background
        layout="prev, pager, next"
        prev-text="< 上一页"
        next-text="下一页 >"
        :total="total">
      </el-pagination>
    </div>

  </div>


</template>

<script>
import Sorter from   '../../..//ivew/pagination'
import { jump, getUser } from '@/untils/auth'
export default {
  name: "ZhuantiFenList",
  components:{
    Sorter
  },
  data() {
    return {
      rows: [],
      name: "",
      total: 0,
      pageSize: 12,
      currentPage: 1,
      categoryname: "",
      data: [],
      // fenZhuantiList: [],
      dialogTableVisible: false,

      labelList: [],

      zhuantiTitle:'',
      zhuantiImg:'',
      serarchVal:'',
      VConfigId:'',
    }
  },
  created() {

    var VConfigId =this.$route.query.VConfigId;
    this.VConfigId = VConfigId;
    this.axios.post(window.IPConfig.IP + "/tbConfigFenZhuanti/getById.do?Id=" + VConfigId).then((response) => {
      console.log(response)
      if (response.status == 200) {
        if (response.data.status == 200) {
          // 列表赋值
          this.zhuantiTitle = response.data.obj.VName;
          // this.serarchVal = response.data.obj.VKey;
          // this.zhuantiImg = response.data.url+response.data.obj.VIndexLine;
        }
      }
    });



    this.getData();
  },
  methods: {
    jump,
    // 切换页码事件
    getPage(val){
      this.currentPage = val;
      this.getData();
    },
    // 跳转图片详情
    toImg(VAttachmentId){
      let routeData = this.$router.resolve({path:'imageDetails',query:{
          VProductId: VAttachmentId
        }})

      window.open(routeData.href,'_blank')

    },



    // 图片列表   点击搜索
    getData() {
      var data = {
        VConfigId:this.VConfigId,
        size: this.pageSize,
        current: this.currentPage,
      }
      this.axios.post(window.IPConfig.IP + "/tbZhuantiFenAttach/queryFenZhuantiAttach.do", data).then((res) => {
        this.rows = [];
        if (res.data.status == 200) {
          this.rows = res.data.obj ? res.data.obj : [];

          this.total = Number(res.data.total);
        }
      });
    },




  },
};
</script>
<style lang="stylus" scoped>
.ssr-pager {
  padding: 40px 0;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  color: #606266
}

.ssr-pager .ssr-pager__pager-box {
  display: inline-block
}

.ssr-pager .ssr-pager__pager-box .btn {
  display: inline-block;
  border: none;
  background: #eaedef;
  width: 68px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  color: #333;
  text-align: center;
  transition: all .3s ease
}

.ssr-pager .ssr-pager__pager-box .btn:hover {
  background: #e2e6e9
}

.ssr-pager .ssr-pager__pager-box .btn:hover.disabled {
  background: #f5f9fc
}

.ssr-pager .ssr-pager__pager-box .btn.disabled {
  cursor: not-allowed;
  color: #c0c4cc
}

.ssr-pager .ssr-pager__pager-box .btn.disabled:hover {
  color: #c0c4cc
}

.ssr-pager .ssr-pager__pager-box .pager-ul {
  display: inline-block;
  margin: 0 4px;
  vertical-align: top
}

.ssr-pager .ssr-pager__pager-box .pager-ul .number {
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  margin: 0 5px;
  box-sizing: border-box;
  text-align: center;
  min-width: 40px;
  height: 36px;
  background: #e9eaed;
  color: #606266;
  border-radius: 4px;
  cursor: pointer;
  padding: 0 8px;
  transition: all .3s ease
}

.ssr-pager .ssr-pager__pager-box .pager-ul .number.point {
  line-height: 36px;
  position: relative
}

.ssr-pager .ssr-pager__pager-box .pager-ul .number.point:hover {
  background: #eaedef
}

.ssr-pager .ssr-pager__pager-box .pager-ul .number.active {
  background: #2cbe99;
  color: #fff
}

.ssr-pager .ssr-pager__pager-box .pager-ul .number.active:hover {
  color: #fff;
  cursor: default;
  background: #2cbe99
}

.ssr-pager .ssr-pager__pager-box .pager-ul .number:hover {
  background: #e2e6e9
}

.ssr-pager .ssr-pager__pager-box .pager-jump {
  display: inline-block;
  margin: 0 10px 0 30px
}

.ssr-pager .ssr-pager__pager-box .pager-jump .jump-input {
  width: 50px;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  text-align: center;
  display: inline-block;
  font-size: inherit;
  height: 28px;
  padding: 0 3px;
  line-height: 28px;
  outline: 0;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1)
}

.ssr-pager input::-webkit-inner-spin-button,.ssr-pager input::-webkit-outer-spin-button {
  -webkit-appearance: none
}

.ssr-pager input[type=number] {
  -moz-appearance: textfield
}

.ssr-pager button {
  outline: none
}

.ssr-pager a {
  text-decoration: none
}

.picalbums-detail-top[data-v-d043b1dc] {
  display: flex;
  align-items: flex-start
}

.picalbums-detail-top .picalbums-detail-top__cover[data-v-d043b1dc] {
  width: 330px;
  height: 220px;
  background-color: #fff;
  padding: 6px;
  margin-right: 36px
}

.picalbums-detail-top .picalbums-detail-top__cover img[data-v-d043b1dc] {
  height: 100%;
  width:100%;
  //-o-object-fit: cover;
  //object-fit: cover
}

.picalbums-detail-top .picalbums-detail-top__info[data-v-d043b1dc] {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  color: #000
}

.picalbums-detail-top .picalbums-detail-top__info .picalbums-detail-top__title[data-v-d043b1dc] {
  display: flex;
  justify-content: space-between
}

.picalbums-detail-top .picalbums-detail-top__info .picalbums-detail-top__title h2[data-v-d043b1dc] {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 40px;
  font-weight: 500;
  line-height: 67px
}

.picalbums-detail-top .picalbums-detail-top__info span[data-v-d043b1dc] {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 28px
}

.picalbums-detail-top .picalbums-detail-top__info .picalbums-detail-top__tag-list[data-v-d043b1dc] {
  display: flex;
  flex-wrap: wrap
}

.picalbums-detail-top .picalbums-detail-top__info .picalbums-detail-top__tag-list .picalbums-detail-top__tag-item[data-v-d043b1dc] {
  height: 34px;
  border-radius: 4px;
  border: 1px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 26px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  transition: all .3s ease;
  margin-right: 12px;
  margin-bottom: 12px
}

.picalbums-detail-top .picalbums-detail-top__info .picalbums-detail-top__tag-list .picalbums-detail-top__tag-item[data-v-d043b1dc]:last-child {
  margin-left: 0
}

.picalbums-detail-top .picalbums-detail-top__info .picalbums-detail-top__tag-list .picalbums-detail-top__tag-item[data-v-d043b1dc]:hover {
  background-color: rgba(0,0,0,.06)
}

.picalbum-detail {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.7rem;
}

.picalbum-detail .picalbums-detail__bac {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}

.picalbum-detail .picalbums-detail__bac img {
  display: block;
  width: 100%;
  height :100%;
}

.picalbum-detail .picalbums-detail__bac img {
  -o-object-fit: cover;
  object-fit: cover
}

.picalbum-detail .picalbums-detail__bac .picalbums-detail__bac-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg,hsla(0,0%,100%,.719),#fff)
}

.picalbum-detail .picalbum-detail__content {
  position: relative;
  width: 1200px
}

.picalbum-detail .picalbum-detail__content .picalbum-detail__top {
  margin: 55px 36px 30px 0
}


.asw {
  display: flex;
  flex-wrap:wrap;
}

.asw .asw__i-i-w {
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
  background-color: #eee;
  transition: transform .3s ease
}

.asw .asw__i-i-w.asw__i-i-w--hover:hover {
  z-index: 1;
  transform: scale(1.3);
  box-shadow: 0 40px 100px 0 rgba(0,0,0,.6)
}

.asw .asw__i-i-w .asw__img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  transition: opacity .2s ease;
  opacity: 0
}

.asw .asw__i-i-w .asw__img.lazy {
  opacity: 1
}

.asw .asw__i-i-w .asw__e-i {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}

.asw .asw__i-i-w .asw__e-i .extra {
  display: block;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  bottom: 0;
  color: #fff;
  height: 30px;
  width: 100%;
  transition: all .2s;
  background-image: linear-gradient(180deg,transparent,rgba(0,0,0,.7))
}

.asw .asw__i-i-w .asw__e-i .extra .eit {
  padding: 0 10px;
  width: 100%;
  max-width: 260px;
  line-height: 30px;
  font-size: 14px;
  color: hsla(0,0%,100%,.8);
  display: block;
  position: absolute;
  pointer-events: none;
  white-space: nowrap;
  letter-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 2px 10px rgba(0,0,0,.3)
}

.asw .asw__i-i-w .asw__e-i:hover .extra {
  opacity: 1
}



.inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636] {
  grid-template-rows:repeat(3, 170px);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 20px;
  -moz-column-gap: 20px;
  column-gap: 20px;
  grid-row-gap: 24px;
  row-gap: 24px;

}



.inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636]::last-child {
  margin-bottom: 0
}

.inspiration .inspiration__content .inspiration__content-item-list .inspiration__stairscoat[data-v-49099636] {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}



.default-cover[data-v-2ee9cf5e] {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%
}

.default-cover .default-cover__top .default-cover__hot-icon[data-v-2ee9cf5e] {
  width: 15%;
  max-width: 62px
}


.hot-topic-box[data-v-76ef6247] {
  width: 100%;
  display: grid;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  grid-template-columns: repeat(3,476px);
  grid-template-rows: repeat(2,260px)
}


@media screen and (max-width: 1681px) {
  .hot-topic-box[data-v-76ef6247] {
    grid-template-columns:repeat(3,385px);
    grid-template-rows: repeat(2,243px)
  }
}

@media screen and (min-width: 1920px) {
  .hot-topic-box[data-v-76ef6247] {
    grid-template-columns:repeat(3,520px);
    grid-template-rows: repeat(2,300px)
  }
}

[am-theme~=warm] .content {
  background-color: #9acd32;
  color: red
}

@media only screen and (max-width: 768px) {
  [am-hidden~=xs] {
    display:none!important
  }
}

@media only screen and (max-width: 1200px) {
  [am-hidden~=md] {
    display:none!important
  }
}

@media screen and (min-width: 1681px)and (max-width:1919px) {
  [am-width~=md] {
    width:1468px!important
  }
}

@media screen and (min-width: 1920px) {
  [am-hidden~=lg] {
    display:none!important
  }
}

@media screen and (max-width: 1680px) {
  [am-width~=md] {
    width:1200px!important;
  }
}

.paixin-home__center[data-v-d4d5db06] {
  /* width:1600px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
  background-color: #fff
}



.s-c {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center
}

.s-c:hover .s-c__i--s {
  transform: scale(1.1)
}

.s-c .s-c__b1 {
  height: 3%;
  width: 90%;
  background-color: #eee
}

.s-c .s-c__b2 {
  height: 5%;
  //width: 95%;
  background-color: #f5f5f5;
  border-radius: 4px
}

.s-c .s-c__ct {
  position: relative;
  height: 93%;
  width: 100%;
  border-radius: 4px;
  overflow: hidden
}

.s-c .s-c__ct .lazyload {
  opacity: 0
}

.s-c .s-c__ct .s-c__img {
  height: 250px;
  width :280px;
  -o-object-fit: cover;
  object-fit: cover;
  transition: all .3s ease
}

.s-c .s-c__ct .s-c__img.lazy {
  opacity: 1
}

.s-c .s-c__ct .s-c__if {
  position: absolute;
  top: 0;
  left: 0;
  //width: 100%;
  height: 100%
}


.inspiration[data-v-49099636] {
  display: flex;
  height auto !important;
  padding-bottom : 30px !important;
}

.inspiration .inspiration__side[data-v-49099636] {
  position: -webkit-sticky;
  position: sticky;
  top: 100px;
  display: flex;
  flex-direction: column;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  min-width: 128px;
  max-width: 128px;
  margin-right: 60px
}

@media screen and (max-width: 1600px) {
  .inspiration .inspiration__side[data-v-49099636] {
    margin-right:36px
  }
}

.inspiration .inspiration__side .inspiration__side-item[data-v-49099636] {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 42px;
  border-radius: 21px;
  background-color: #f5f5f7;
  transition: all .3s ease;
}

.inspiration .inspiration__side .inspiration__side-item[data-v-49099636]:hover {
  background-color: #e9e9eb
}

.inspiration .inspiration__side .inspiration__side-item:hover.inspiration__side-item--active[data-v-49099636] {
  background-color: #f71558
}

.inspiration .inspiration__side .inspiration__side-item.inspiration__side-item--active[data-v-49099636] {
  background-color: #f71558;
  color: #fff;
  font-weight: 600
}

.inspiration .inspiration__content[data-v-49099636] {
  flex: 1 1
}

.inspiration .inspiration__content .inspiration__content-item-top[data-v-49099636] {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inspiration .inspiration__content .inspiration__content-item-top .inspiration__content-item-title[data-v-49099636] {
  display: flex;
  align-items: center
}

.inspiration .inspiration__content .inspiration__content-item-top .inspiration__content-item-title .inspiration__dot[data-v-49099636] {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: #f71558;
  margin-right: 13px
}

.inspiration .inspiration__content .inspiration__content-item-top .inspiration__content-item-title h3[data-v-49099636] {
  font-size: 22px;
  font-weight: 500;
  color: #000;
  line-height: 30px
}

.inspiration .inspiration__content .inspiration__content-item-top .inspiration__change-btn[data-v-49099636] {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.inspiration .inspiration__content .inspiration__content-item-top .inspiration__change-btn img[data-v-49099636] {
  width: 16px;
  margin-right: 6px
}

.inspiration .inspiration__content .inspiration__content-item-top .inspiration__change-btn span[data-v-49099636] {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  line-height: 20px
}



@media screen and (min-width: 1681px)and (max-width:1919px) {
  .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636] {
    grid-template-rows:repeat(3, 206px);
  }
}

@media screen and (max-width: 1680px) {
  .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636] {
    grid-template-rows:repeat(3, 170px);
    grid-column-gap: 16px;
    -moz-column-gap: 16px;
    column-gap: 16px;
    grid-row-gap: 18px;
    row-gap: 18px
  }
}

.inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636]::last-child {
  margin-bottom: 0
}


a[data-v-38268b2c] {
  white-space: nowrap
}

.pop[data-v-38268b2c] {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 12%
}

.pop a[data-v-38268b2c] {
  width: 34%;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  display: inline-block;
  padding: 6px 0
}

.pop a[data-v-38268b2c]:hover {
  color: #ff004b
}

.default-cover[data-v-2ee9cf5e] {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%
}

.default-cover .default-cover__top .default-cover__hot-icon[data-v-2ee9cf5e] {
  width: 15%;
  max-width: 62px
}

.default-cover .default-cover__bottom[data-v-2ee9cf5e] {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 0 20px 20px;
  height: 90px;
  background: linear-gradient(180deg,transparent,rgba(0,0,0,.6));
  color: #fff
}

.default-cover .default-cover__bottom .default-cover__title-text[data-v-2ee9cf5e] {
  font-size: 16px;
  font-weight: 600
}

.default-cover .default-cover__bottom .default-cover__img-num[data-v-2ee9cf5e] {
  opacity: .8;
  margin-top: 2%;
  font-size: 14px
}


.s-c__ct img {
  display: block;
  width: 100%;
}


.asw {
  display: flex;
  flex-wrap: wrap
}

.asw .asw__i-i-w {
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
  background-color: #eee;
  transition: transform .3s ease
}

.asw .asw__i-i-w.asw__i-i-w--hover:hover {
  z-index: 1;
  transform: scale(1.3);
  box-shadow: 0 40px 100px 0 rgba(0,0,0,.6)
}

.asw .asw__i-i-w .asw__img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  transition: opacity .2s ease;
  opacity: 0
}

.asw .asw__i-i-w .asw__img.lazy {
  opacity: 1
}

.asw .asw__i-i-w .asw__e-i {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}

.asw .asw__i-i-w .asw__e-i .extra {
  display: block;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  bottom: 0;
  color: #fff;
  height: 30px;
  width: 100%;
  transition: all .2s;
  background-image: linear-gradient(180deg,transparent,rgba(0,0,0,.7))
}

.asw .asw__i-i-w .asw__e-i .extra .eit {
  padding: 0 10px;
  width: 100%;
  max-width: 260px;
  line-height: 30px;
  font-size: 14px;
  color: hsla(0,0%,100%,.8);
  display: block;
  position: absolute;
  pointer-events: none;
  white-space: nowrap;
  letter-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 2px 10px rgba(0,0,0,.3)
}

.asw .asw__i-i-w .asw__e-i:hover .extra {
  opacity: 1
}

</style>



// WEBPACK FOOTER //
// src/components/Education/components/index/zhuantiFenList.vue